var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 79,
    viewBox: "0 0 68 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 34C0 15.2223 15.2223 0 34 0C52.7777 0 68 15.2223 68 34C68 50.0831 56.833 63.5581 41.8295 67.0941C40.5685 67.3913 39.472 68.2004 38.9118 69.3686L34.9017 77.7298C34.5387 78.4865 33.4613 78.4865 33.0983 77.7298L29.0882 69.3686C28.528 68.2004 27.4315 67.3913 26.1705 67.0941C11.1671 63.5581 0 50.0831 0 34Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.896 22.9277C30.6745 22.1077 29.1041 22.0313 27.8098 22.7288C26.5155 23.4263 25.7075 24.7845 25.7075 26.2627V42.2952C25.7075 43.7733 26.5155 45.1315 27.8098 45.829C29.1041 46.5265 30.6745 46.4501 31.896 45.6301L43.8374 37.6139C44.9448 36.8705 45.61 35.619 45.61 34.2789C45.61 32.9388 44.9448 31.6873 43.8374 30.9439L31.896 22.9277Z",
    fill: "url(#paint0_linear_9020_14609)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9020_14609",
    x1: 25.7075,
    y1: 34.2789,
    x2: 45.6433,
    y2: 34.2789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C414FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#471FF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.1cc7c18c188dddbba263799f5d68ea92.svg";
export { ForwardRef as ReactComponent };